/**
 * Cili email përdoret për punëtorin: personal apo i kompanisë.
 *
 * Aty shkojnë njoftimet, oraret dhe vendimet (backend: services/contactEmail.js).
 * Kur e zgjedhura është bosh, sistemi përdor tjetrën — ndaj zgjedhja e
 * paplotësuar paralajmërohet, jo bllokohet. Dokumentet e largimit shkojnë
 * gjithmonë te email-i personal: ai i punës mbyllet me largimin.
 */
import React from 'react';
import { Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';

export default function PreferredEmailPicker({ control, watch }) {
  const pref = watch('PreferredEmail') || 'personal';
  const personal = String(watch('Email') || '').trim();
  const work = String(watch('WorkEmail') || '').trim();
  const chosen = pref === 'work' ? work : personal;
  const fallback = pref === 'work' ? personal : work;

  return (
    <Box>
      <Typography sx={{ fontSize: 11, color: 'text.secondary', mb: 0.5, fontWeight: 600 }}>
        Email-i që përdoret për njoftime
      </Typography>
      <Controller
        name="PreferredEmail"
        control={control}
        render={({ field }) => (
          <ToggleButtonGroup
            exclusive size="small" fullWidth color="primary"
            value={field.value || 'personal'}
            onChange={(_, v) => { if (v) field.onChange(v); }}
            sx={{ '& .MuiToggleButton-root': { textTransform: 'none', gap: 0.75, py: 0.75 } }}
          >
            <ToggleButton value="personal"><PersonOutlineIcon sx={{ fontSize: 18 }} />Personal</ToggleButton>
            <ToggleButton value="work"><BusinessCenterOutlinedIcon sx={{ fontSize: 18 }} />I punës</ToggleButton>
          </ToggleButtonGroup>
        )}
      />
      <Typography sx={{ fontSize: 11, mt: 0.5, color: chosen ? 'text.secondary' : 'warning.dark' }}>
        {chosen
          ? <>Njoftimet shkojnë te <b>{chosen}</b></>
          : fallback
            ? <>Ky email është bosh — deri sa të plotësohet, përdoret <b>{fallback}</b></>
            : 'Plotëso të paktën njërin email'}
      </Typography>
    </Box>
  );
}
